<template>
  <Message
    v-if="isShowing"
    severity="warn"
    :closable="false"
    :sticky="true"
    class="flex justify-content-center"
    data-cy="conflict-banner-message"
  >
    <div
      class="container flex align-items-center justify-content-center flex-wrap"
    >
      There is a conflict
      <router-link :to="{ name: 'User' }" class="p-decoration-none" data-cy="conflict-fix-link">
        <Button
          label="Click here to fix"
          class="p-button-sm p-button-outlined p-button-success mx-3"
          data-cy="conflict-fix-button"
        />
      </router-link>
      <span data-cy="conflict-count">{{ numConflicts }} update{{ numConflicts > 1 ? "s" : "" }} pending</span>
    </div>
  </Message>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import Message from "primevue/message";
import Button from "primevue/button";
import { useConflictRevisions } from "@/composables/conflict/revisions";

const { revisionConflicts } = useConflictRevisions({});
const isShowing = computed(() => revisionConflicts.value.length > 0);

const numConflicts = computed(() => revisionConflicts.value.length);

// scroll to top of page when items are added to backlog
// so the Message is shown to the user
watch(revisionConflicts, (newConflicts, oldConflicts) => {
  if (newConflicts.length > oldConflicts.length) {
    window.scrollTo({ left: 0, top: 0 });
  }
});
</script>